export default __webpack_public_path__ + "static/media/chevron_left_color.d9e1a948.svg";